import styled from "styled-components"

export const TestComponentStyle = styled.div`
 width:100%;
 height:auto;

 .green_color{
     color:green
 }
`